import React, { useEffect } from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { atomLog } from 'utils/logUtil'

type Props = {
  key?: number
  tab?: number
  label: string
  check?: boolean
  position?: 'start' | 'end' | 'top' | 'bottom'
  change: (e: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean
  color?: 'primary' | 'secondary' | 'default'
  alertLabel?: string
}

/**
 * 右にラベルが付いてるチェックボックス
 * key?: number
 * tab?: number
 * label: string
 * check?: boolean
 * position?: 'start' | 'end' | 'top' | 'bottom'
 * change: (e: React.ChangeEvent<HTMLInputElement>) => void
 * disabled?: boolean
 * @param param0
 * @returns
 */
const A_FieldCheckBoxRight = ({
  key = 0, //
  tab = -1,
  label,
  check = false,
  position = 'start',
  change,
  disabled = false,
  color = 'primary',
  alertLabel = '',
}: Props) => {
  useEffect(() => atomLog('A_FieldCheckBoxRight'))
  if (position === 'start') {
    return (
      <FormControlLabel
        key={key} //
        tabIndex={tab}
        value={check}
        style={{ marginTop: 0, marginBottom: 5, marginLeft: 0, marginRight: 0, padding: 0 }}
        control={
          <Checkbox
            checked={check}
            style={{ backgroundColor: 'white', margin: 0, padding: 0 }} //
            color={color}
            onChange={change}
          />
        }
        label={
          <>
            <span>{label}</span>
            <span>{alertLabel}</span>
          </>
        }
        labelPlacement={position}
        disabled={disabled}
      />
    )
  }
  return (
    <FormControlLabel
      key={key} //
      tabIndex={tab}
      value={check}
      style={{ marginTop: 0, marginBottom: 5, marginLeft: 0, marginRight: 0, padding: 0 }}
      control={
        <Checkbox
          checked={check}
          style={{ backgroundColor: 'white', margin: 0, padding: 0 }} //
          color={color}
          onChange={change}
        />
      }
      label={
        <>
          <span>{label}</span>
          <span style={{ color: 'red' }}>{alertLabel}</span>
        </>
      }
      labelPlacement={position}
      disabled={disabled}
    />
  )
}
export default React.memo(A_FieldCheckBoxRight)
